import React from 'react';
import { useHeaderTheme } from '../../theme';
import useStyles from './useStylesMenuButton';

export type MobileMenuButtonProps = {
  showMobileNav: boolean;
  toggleMobileNav(): void;
};

export const MobileMenuButton = ({
  showMobileNav,
  toggleMobileNav,
}: MobileMenuButtonProps) => {
  const theme = useHeaderTheme();
  const classes = useStyles({ showMobileNav, theme });

  return (
    <button
      className={classes.menuButton}
      onClick={toggleMobileNav}
      type="button"
      data-testid="mobile-menu-button"
    >
      <div className={classes.menuButtonLineTop} />
      <div className={classes.menuButtonLineMiddleLeft} />
      <div className={classes.menuButtonLineMiddleRight} />
      <div className={classes.menuButtonLineBottom} />
    </button>
  );
};

export default MobileMenuButton;
